import { ImportRecord } from "@/types/fileImport";
import http from "./http";

export async function getFileRecords() {
    try {
        const res = await http.get<Array<ImportRecord>>("/api/auth/file-records");
        console.log(res);
        return res.data;
    } catch (e) {
        console.log('getFileRecords error >>> ', e);
        return [];
    }
}

export async function getSingleRecord(id: string) {
        const res = await http.get<ImportRecord>(`api/auth/file-records/${id}`);
        console.log(res);
        return res.data;
}

export async function getBenefits() {
    try {
        const res = await http.get<{ benefit: number; benefitUsed: number }>("/api/auth/file-records/benefits");
        return res.data;
    } catch (e) {
        console.log('getBenefits error >>> ', e);
        throw e;
    }
}

export async function addFileToTransform(fileName: string, fileKey: string, fileSize: number, duration: number) {
    try {
        const res = await http.post<string>("/api/auth/file-records", {
            fileName,
            fileKey,
            fileSize,
            duration
        });
        return res.data;
    } catch (e) {
        console.log('getBenefits error >>> ', e);
        return '';
    }
}

export async function retryTransform(id: string) {
    try {
        await http.patch(`/api/auth/file-records/${id}/actions/retry`);
        return true;
    } catch (e) {
        console.log('retryTransform error >>> ', e);
        return false;
    }
}

export async function cancelTransform(id: string) {
    try {
        await http.patch(`/api/auth/file-records/${id}/actions/cancel`);
        return true;
    } catch (e) {
        console.log('cancelTransform error >>> ', e);
        return false;
    }
}